import type { TimelineItem } from "@/mocks/events";

interface StoryTimelineProps {
  items: TimelineItem[];
  count: number;
}

export default function StoryTimeline({ items, count }: StoryTimelineProps) {
  return (
    <section id="timeline" className="scroll-mt-28 pt-10">
      <h2 className="flex items-center gap-2.5 text-xl font-bold text-foreground-950 md:text-2xl">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
          <i className="ri-time-line" aria-hidden="true"></i>
        </span>
        完整时间线还原
      </h2>
      <p className="mt-3 flex items-center gap-1.5 text-sm text-foreground-600">
        <i className="ri-information-line text-accent-600" aria-hidden="true"></i>
        共 {count} 个关键节点 · 时间均为事件实际发生的公开口径日期
      </p>

      <div className="relative mt-7">
        {/* 中线 */}
        <span
          className="absolute bottom-2 left-[86px] top-2 w-px bg-gradient-to-b from-primary-300 via-secondary-300 to-transparent md:left-[116px]"
          aria-hidden="true"
        ></span>
        <ol className="space-y-4">
          {items.map((item, idx) => (
            <li key={`${item.time}-${idx}`} className="relative flex gap-4 md:gap-6">
              {/* 日期 */}
              <div className="flex w-[76px] shrink-0 items-center justify-end md:w-[106px]">
                <span className="rounded-lg bg-primary-100 px-2 py-1 font-mono text-xs font-bold text-primary-700">
                  {item.time}
                </span>
              </div>
              {/* 节点 */}
              <span
                className={`relative z-10 mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-4 ${
                  idx === 0
                    ? "border-primary-200 bg-primary-500"
                    : idx === count - 1
                      ? "border-accent-200 bg-accent-500"
                      : "border-background-200 bg-secondary-400"
                }`}
                aria-hidden="true"
              ></span>
              {/* 内容 */}
              <div className="min-w-0 flex-1 pb-1">
                <div className="rounded-2xl bg-background-100 p-4 md:p-5">
                  <span className="flex items-center gap-2 text-xs text-foreground-500">
                    <i
                      className={`${
                        idx === 0 ? "ri-play-circle-line" : idx === count - 1 ? "ri-checkbox-circle-line" : "ri-record-circle-line"
                      } text-base ${
                        idx === 0
                          ? "text-primary-500"
                          : idx === count - 1
                            ? "text-accent-600"
                            : "text-secondary-400"
                      }`}
                      aria-hidden="true"
                    ></i>
                    第 {idx + 1} 步 · {idx === 0 ? "事件起点" : idx === count - 1 ? "尘埃落定" : "关键转折"}
                  </span>
                  <h3 className="mt-1.5 text-[15px] font-bold text-foreground-900">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">
                    {item.text}
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}